var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 768,
    height: 768,
    viewBox: "0 0 768 768",
    fill: "#e7e5fc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 64,
    y1: 0,
    x2: 64,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 96,
    y1: 0,
    x2: 96,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 112,
    y1: 0,
    x2: 112,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 144,
    y1: 0,
    x2: 144,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 176,
    y1: 0,
    x2: 176,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 192,
    y1: 0,
    x2: 192,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 208,
    y1: 0,
    x2: 208,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 224,
    y1: 0,
    x2: 224,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 240,
    y1: 0,
    x2: 240,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 256,
    y1: 0,
    x2: 256,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 272,
    y1: 0,
    x2: 272,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 288,
    y1: 0,
    x2: 288,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 304,
    y1: 0,
    x2: 304,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 320,
    y1: 0,
    x2: 320,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 336,
    y1: 0,
    x2: 336,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 352,
    y1: 0,
    x2: 352,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 368,
    y1: 0,
    x2: 368,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 384,
    y1: 0,
    x2: 384,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 416,
    y1: 0,
    x2: 416,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 432,
    y1: 0,
    x2: 432,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 448,
    y1: 0,
    x2: 448,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 464,
    y1: 0,
    x2: 464,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 480,
    y1: 0,
    x2: 480,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 496,
    y1: 0,
    x2: 496,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 512,
    y1: 0,
    x2: 512,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 528,
    y1: 0,
    x2: 528,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 544,
    y1: 0,
    x2: 544,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 560,
    y1: 0,
    x2: 560,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 576,
    y1: 0,
    x2: 576,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 592,
    y1: 0,
    x2: 592,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 608,
    y1: 0,
    x2: 608,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 624,
    y1: 0,
    x2: 624,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 640,
    y1: 0,
    x2: 640,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 656,
    y1: 0,
    x2: 656,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 672,
    y1: 0,
    x2: 672,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 688,
    y1: 0,
    x2: 688,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 704,
    y1: 0,
    x2: 704,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 720,
    y1: 0,
    x2: 720,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 736,
    y1: 0,
    x2: 736,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 752,
    y1: 0,
    x2: 752,
    y2: 768,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 16,
    x2: 768,
    y2: 16,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 32,
    x2: 768,
    y2: 32,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 48,
    x2: 768,
    y2: 48,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 64,
    x2: 768,
    y2: 64,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 80,
    x2: 768,
    y2: 80,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 96,
    x2: 768,
    y2: 96,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 112,
    x2: 768,
    y2: 112,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 128,
    x2: 768,
    y2: 128,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 144,
    x2: 768,
    y2: 144,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 160,
    x2: 768,
    y2: 160,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 176,
    x2: 768,
    y2: 176,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 192,
    x2: 768,
    y2: 192,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 208,
    x2: 768,
    y2: 208,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 224,
    x2: 768,
    y2: 224,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 240,
    x2: 768,
    y2: 240,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 256,
    x2: 768,
    y2: 256,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 272,
    x2: 768,
    y2: 272,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 288,
    x2: 768,
    y2: 288,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 304,
    x2: 768,
    y2: 304,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 320,
    x2: 768,
    y2: 320,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 336,
    x2: 768,
    y2: 336,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 352,
    x2: 768,
    y2: 352,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 368,
    x2: 768,
    y2: 368,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 384,
    x2: 768,
    y2: 384,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 400,
    x2: 768,
    y2: 400,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 416,
    x2: 768,
    y2: 416,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 432,
    x2: 768,
    y2: 432,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 448,
    x2: 768,
    y2: 448,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 464,
    x2: 768,
    y2: 464,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 480,
    x2: 768,
    y2: 480,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 496,
    x2: 768,
    y2: 496,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 512,
    x2: 768,
    y2: 512,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 528,
    x2: 768,
    y2: 528,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 544,
    x2: 768,
    y2: 544,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 560,
    x2: 768,
    y2: 560,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 576,
    x2: 768,
    y2: 576,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 592,
    x2: 768,
    y2: 592,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 608,
    x2: 768,
    y2: 608,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 624,
    x2: 768,
    y2: 624,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 640,
    x2: 768,
    y2: 640,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 656,
    x2: 768,
    y2: 656,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 672,
    x2: 768,
    y2: 672,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 688,
    x2: 768,
    y2: 688,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 704,
    x2: 768,
    y2: 704,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 720,
    x2: 768,
    y2: 720,
    stroke: "#e7e5fc",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 736,
    x2: 768,
    y2: 736,
    stroke: "#e7e5fc",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 752,
    x2: 768,
    y2: 752,
    stroke: "#e7e5fc",
    opacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M768 695.963c0 0.012 0 0.028 0 0.045 0 39.761-32.231 71.993-71.993 71.993-13.253 0-25.667-3.581-36.337-9.829l0.338 0.186-551.932-311.963c-21.716-12.666-36.076-35.852-36.076-62.391s14.363-49.725 35.732-62.207l0.341-0.187 551.932-311.962c10.325-6.062 22.744-9.647 35.993-9.647 39.761 0 71.992 32.231 71.992 71.992 0 0.017 0 0.032 0 0.049v-0.003z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.aefdae3dabcc1a89ed8842fdecc4f82c.svg";
export { ForwardRef as ReactComponent };